module.exports = __webpack_public_path__ + "img/logo-em.2c730169.svg";